import {
  useLogout,
  useResendVerificationEmail,
  useUser,
} from '@/framework/user';
import Button from '@/components/ui/button';
import Card from '@/components/ui/cards/card';
import Logo from '@/components/ui/logo';
import { useToken } from '@/lib/hooks/use-token';
import { useRouter } from 'next/router';
import Link from '@/components/ui/link';
import { Routes } from '@/config/routes';

export { getStaticProps } from '@/framework/general.ssr';

const VerifyEmail = () => {
  const { getEmailVerified } = useToken();
  const router = useRouter();
  const { emailVerified } = getEmailVerified();
  const { mutate: logout, isLoading: isLogoutLoader } = useLogout();
  useUser();

  if (emailVerified) {
    router.push('/profile');
  }
  const handleLogout = () => {
    logout();
    router.push(Routes.home);
  };
const { mutate: verifyEmail, isLoading: isVerifying } =
    useResendVerificationEmail();

  return (
    <section className="relative flex min-h-screen w-full items-center justify-center bg-[#F4F6F7] py-5 px-4 md:py-8">
      <div className="max-w-[36rem]">
        <Card className="text-center !shadow-900 md:px-[4.375rem] md:py-[2.875rem]">
          <Logo />

          <h2 className="mb-5 mt-2 text-2xl font-semibold">
            {"Seu e-mail ainda não foi verificado."}
          </h2>

          <p className="mb-16 text-lg text-[#969FAF]">
            {"Obrigado por se inscrever! Antes de começar, você poderia verificar seu endereço de e-mail clicando no link que acabamos de enviar para você? Se você não recebeu o e-mail, ficaremos felizes em enviar outro."}
          </p>

          <div className="space-y-3">
            <Button
              onClick={() => verifyEmail()}
              disabled={isVerifying || !!isLogoutLoader}
              loading={isVerifying}
              className="!h-13 w-full hover:bg-accent-hover"
            >
              {"Reenviar E-mail de Verificação"}
            </Button>
            <Button
              type="button"
              variant="outline"
              className="!h-13 w-full"
              onClick={() => handleLogout()}
              disabled={!!isVerifying || isLogoutLoader}
              loading={isLogoutLoader}
            >
              {"Sair"}
            </Button>
          </div>
          <div className="mt-4">
            <Link
              href={Routes.home}
              className="inline-flex items-center text-bolder underline hover:text-body-dark hover:no-underline focus:outline-none sm:text-base"
            >
              {"Leve-me para casa"}
            </Link>
          </div>
        </Card>
      </div>
    </section>
  );
};
VerifyEmail.authenticationRequired = true;
export default VerifyEmail;
